var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"m-0 p-0 header-units",attrs:{"align-v":"center"}},[_c('b-col',[_c('p',{staticClass:"c"})]),_c('b-col',[_c('p',{staticClass:"header_config"},[_vm._v(" Input ")])]),_c('b-col',[_c('p',{staticClass:"header_config"},[_vm._v(" Output ")])]),_c('b-col',[_c('p',{staticClass:"header_config"},[_vm._v(" Log ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }